import script from "./software-usage-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./software-usage-list.vue?vue&type=script&setup=true&lang=ts"

import "./software-usage-list.vue?vue&type=style&index=0&id=bad39a58&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bad39a58"]])

export default __exports__